/**
 * Single source of truth mapping a beam material to its backend API route prefix
 * and its frontend page route. Beam analysis is served per material
 * (concrete / wood / steel); callers derive routes from the material rather than
 * hardcoding them.
 */

export type BeamMaterial = 'concrete' | 'steel' | 'timber'

const BEAM_API_BASE: Record<BeamMaterial, string> = {
  concrete: '/api/concrete-beam',
  steel: '/api/steel-beam',
  timber: '/api/wood-beam'
}

const BEAM_PAGE_ROUTE: Record<BeamMaterial, string> = {
  concrete: '/beam/concrete',
  steel: '/beam/steel',
  timber: '/beam/wood'
}

export function beamApiBase(material: string): string {
  const base: string | undefined = BEAM_API_BASE[material as BeamMaterial]
  if (!base) {
    throw new Error(`beamApiBase: unknown beam material '${material}'. Expected one of: ${Object.keys(BEAM_API_BASE).join(', ')}.`)
  }
  return base
}

export function beamRouteForMaterial(material: string): string {
  const route: string | undefined = BEAM_PAGE_ROUTE[material as BeamMaterial]
  if (!route) {
    throw new Error(`beamRouteForMaterial: unknown beam material '${material}'. Expected one of: ${Object.keys(BEAM_PAGE_ROUTE).join(', ')}.`)
  }
  return route
}
